import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLockBodyScroll } from '@as/cotopaxi';
import { BottomSheet, Box, Breakpoint, Sidebar } from '@yonderland/andes-react';
import { createPortal } from 'react-dom';
import ZendeskWidgetUtil from '../../../util/ZendeskWidgetUtil';
import { useEffect } from 'react';
const SIDEBAR_WIDTH = '512px';
export const DeliverySheet = ({ isOpen, onClose, getContent, showCTA, getCTAContent }) => {
    useLockBodyScroll(isOpen);
    useEffect(() => {
        if (isOpen) {
            ZendeskWidgetUtil.updateZIndex(1);
        }
        return () => {
            ZendeskWidgetUtil.resetZIndex();
        };
    }, [isOpen]);
    return createPortal(_jsxs(_Fragment, { children: [_jsx(Breakpoint, { until: "sm", children: _jsxs(BottomSheet, { isOpen: isOpen, fullHeightOnScroll: true, onClose: onClose, padding: "none", testId: "pickup-point-bottom-sheet", children: [_jsx(Box, { paddingBlockStart: "6", paddingBlockEnd: "20", children: getContent() }), showCTA && (_jsx(Sidebar, { isOpen: true, side: "right", align: "bottom", position: "fixed", animation: "none", zIndex: "modal", hasCloseBtn: false, hasBackdrop: false, fullHeight: false, customWidth: "100%", testId: "pickup-point-cta-sidebar", children: getCTAContent() }))] }) }), _jsx(Breakpoint, { from: "sm", children: _jsx(Sidebar, { isOpen: isOpen, onClose: onClose, side: "right", align: "top", position: "fixed", customWidth: SIDEBAR_WIDTH, hasCloseBtnSpacing: false, footer: {
                        content: showCTA && getCTAContent(),
                        position: 'absolute',
                    }, testId: "pickup-point-sidebar", children: _jsx(Box, { paddingBlockStart: "6", children: getContent() }) }) })] }), document.body);
};
